export default __webpack_public_path__ + "static/media/coinLearn__image2.4745100b.svg";